const actionTypes = {
  FETCH_ALL_DEDUCTION_INVOICES_LOADING: 'FETCH_ALL_DEDUCTION_INVOICES_LOADING',
  FETCH_ALL_DEDUCTION_INVOICES_SUCCESS: 'FETCH_ALL_DEDUCTION_INVOICES_SUCCESS',
  FETCH_ALL_DEDUCTION_INVOICES_FAILED: 'FETCH_ALL_DEDUCTION_INVOICES_FAILED',
  FETCH_ALL_DEDUCTION_INVOICES_REJECT: 'FETCH_ALL_DEDUCTION_INVOICES_REJECT',

  CHANGE_DEDUCTION_INVOICE_STATUS_LOADING: 'CHANGE_DEDUCTION_INVOICE_STATUS_LOADING',
  CHANGE_DEDUCTION_INVOICE_STATUS_SUCCESS: 'CHANGE_DEDUCTION_INVOICE_STATUS_SUCCESS',
  CHANGE_DEDUCTION_INVOICE_STATUS_FAILED: 'CHANGE_DEDUCTION_INVOICE_STATUS_FAILED',
  CHANGE_DEDUCTION_INVOICE_STATUS_REJECT: 'CHANGE_DEDUCTION_INVOICE_STATUS_REJECT',

  INSERT_NEW_DEDUCTION_INVOICE_LOADING: 'INSERT_NEW_DEDUCTION_INVOICE_LOADING',
  INSERT_NEW_DEDUCTION_INVOICE_SUCCESS: 'INSERT_NEW_DEDUCTION_INVOICE_SUCCESS',
  INSERT_NEW_DEDUCTION_INVOICE_FAILED: 'INSERT_NEW_DEDUCTION_INVOICE_FAILED',
  INSERT_NEW_DEDUCTION_INVOICE_REJECT: 'INSERT_NEW_DEDUCTION_INVOICE_REJECT',

  DELETE_DEDUCTION_INVOICE_LOADING: 'DELETE_DEDUCTION_INVOICE_LOADING',
  DELETE_DEDUCTION_INVOICE_SUCCESS: 'DELETE_DEDUCTION_INVOICE_SUCCESS',
  DELETE_DEDUCTION_INVOICE_FAILED: 'DELETE_DEDUCTION_INVOICE_FAILED',
  DELETE_DEDUCTION_INVOICE_REJECT: 'DELETE_DEDUCTION_INVOICE_REJECT',

  FETCH_ALL_DEDUCTIONS_DELETEDS_SUCCESS: 'FETCH_ALL_DEDUCTIONS_DELETEDS_SUCCESS',
  FETCH_ALL_DEDUCTIONS_DELETEDS_FAILED: 'FETCH_ALL_DEDUCTIONS_DELETEDS_FAILED',
  FETCH_ALL_DEDUCTIONS_DELETEDS_REJECT: 'FETCH_ALL_DEDUCTIONS_DELETEDS_REJECT',
  FETCH_ALL_DEDUCTIONS_DELETEDS_LOADING: 'FETCH_ALL_DEDUCTIONS_DELETEDS_LOADING'
};

export default actionTypes;
